/*
 * Module for the contribution rate group add page
 */
rs.module("content/system/configuration/contributionrates/add",

    [
        "common/select-helper"
    ],

    function (selectHelper) {

        // initialize the module
        function initialize(jsSelectors, codeValues, backendUrl) {

            // Unpack jsSelectors
            var criteria = $.js(jsSelectors.criteria);

            var rateTypeSelect = criteria.js(jsSelectors.rateTypeSelect);
            var percentInput = criteria.js(jsSelectors.percentInput);
            var tableNameSelect = criteria.js(jsSelectors.tableNameSelect);
            var defineLimitsCheckbox = criteria.js(jsSelectors.defineLimitsCheckbox);
            var singleLimitInput = criteria.js(jsSelectors.singleLimitInput);
            var annualLimitInput = criteria.js(jsSelectors.annualLimitInput);
            var annualLimitTypeSelect = criteria.js(jsSelectors.annualLimitTypeSelect);

            // Grab select helper(s)
            var tableNameSelectHelper = selectHelper.getHelper(tableNameSelect);
            var annualLimitTypeSelectHelper = selectHelper.getHelper(annualLimitTypeSelect);

            // Enable/Disable fields on rate type select
            rateTypeSelect.change(function () {

                var rateType = rateTypeSelect.val();

                if (rateType == codeValues.ageRate || rateType == codeValues.flat) {
                    percentInput.val('').clearErrors().prop('disabled', true);
                    tableNameSelectHelper.setDisabled(false);
                    tableNameSelectHelper.loadOptionsFrom(backendUrl, { rateType: rateTypeSelect.val() });
                }
                else if (rateType == codeValues.percentage) {
                    percentInput.prop('disabled', false);
                    tableNameSelectHelper.setDisabled(true);
                    tableNameSelectHelper.clearOptions();
                }
                else {
                    percentInput.val('').clearErrors().prop('disabled', true);
                    tableNameSelectHelper.setDisabled(true);
                    tableNameSelectHelper.clearOptions();
                }

            });

            // Boolean for determining if we are defining limits
            defineLimitsCheckbox.change(function () {

                var checked = this.checked;

                if (!checked) {
                    singleLimitInput.clearErrors().val('');
                    annualLimitInput.clearErrors().val('');
                    annualLimitTypeSelectHelper.selectIndex(0);
                }

                singleLimitInput.prop('disabled', !checked);
                annualLimitInput.prop('disabled', !checked);
                annualLimitTypeSelectHelper.setDisabled(!checked);
            });
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);